export async function index({commit}, page) {
  const data = await this.$adminRepositories.contacts.index(page);
  commit('setList', data?.data || [])
  return data;
}
